import React, { useEffect, useState } from "react";
import { API_URL } from "./config";
import { useNavigate } from "react-router-dom";


const SelectMinistry = ({ navigation }) => {
    const navigate = useNavigate();
    const [ministries, setMinistries] = useState([]);

    useEffect(() => { 
        const fetchMinistries = async () => {
            const memberId =localStorage.getItem("UserID");
            //console.log(memberId);
            try {
                const response = await fetch(`${API_URL}/ministries/ministry-leaders/${memberId}`, {
                    headers: { "Content-Type": "application/json" }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                setMinistries(data);
                console.log(data);
            } catch (error) {
                console.error('Error fetching sermons:', error);
            }
        };

        fetchMinistries();
    }, []);

    const showMinistry = async (id) => { 
        let result = ministries.find((obj) => obj.id === id);
        console.log(id);
        console.log(result.admin);
        await localStorage.setItem("SelectedMinistry", JSON.stringify(result));
        navigate("/ministryadmin");
    };


    return (
        <div style={containerStyle}>

            <div style={viewMiddleStyle}>
                <h2 style={pageTitleStyle}>Ministry Admin</h2>
                <p style={instructionTextStyle}>
                    Here is the list of ministries that you are an admin. Click to select
                    the one you want to proceed to.
                </p>
                <div style={ministriesContainerStyle}>
                    {ministries.map((ministry) => (
                        <div key={ministry.id} style={ministryCardStyle} onClick={() => showMinistry(ministry.id)}>
                            <div style={ministryInfoStyle}>
                                <h3 style={ministryNameStyle}>{ministry.name}</h3>
                                <p style={ministryDescriptionStyle}>{ministry.description}</p>
                            </div>
                            <div style={ministryArrowStyle}>→</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

// Main container styles
const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "0 20px",
    minHeight: "100vh",
};

// Top section styles
const viewTopStyle = {
    width: "100%",
    marginTop: "35px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
};

const topBarStyle = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
};

const backButtonStyle = {
    fontSize: "25px",
    color: "#000000",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "0",
    width: "30%",
    textAlign: "left"
};

const logoContainerStyle = {
    width: "30%",
    display: "flex",
    justifyContent: "center"
};

const logoImageStyle = {
    width: "100%",
    height: "35px",
    borderRadius: "22.5px",
    objectFit: "cover"
};

const pageTitleStyle = {
    fontFamily: "Arial, sans-serif",
    fontWeight: "normal",
    fontSize: "22px",
    lineHeight: "24px",
    marginTop: "10px",
    alignSelf: "flex-start"
};

// Middle section styles
const viewMiddleStyle = {
    width: "100%",
    marginTop: "30px",
    marginBottom: "65px",
    flexGrow: "1"
};

const instructionTextStyle = {
    fontFamily: "Arial, sans-serif",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "18px",
    marginTop: "10px",
    marginBottom: "10px"
};

// Ministry card styles
const ministriesContainerStyle = {
    width: "100%"
};

const ministryCardStyle = {
    display: "flex",
    alignItems: "center",
    padding: "15px",
    marginBottom: "15px",
    // background: "white",
    backgroundColor: "#f5f5f5",
    borderRadius: "10px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
    cursor: "pointer",
    transition: "transform 0.2s"
};

const ministryImageStyle = {
    width: "50px",
    height: "50px",
    borderRadius: "25px",
    marginRight: "15px"
};

const ministryInfoStyle = {
    flexGrow: "1"
};

const ministryNameStyle = {
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    margin: "0 0 5px 0",
    fontSize: "16px"
};

const ministryDescriptionStyle = {
    fontFamily: "Arial, sans-serif",
    margin: "0",
    fontSize: "14px",
    color: "#666"
};

const ministryArrowStyle = {
    fontSize: "20px",
    color: "#666"
};


export default SelectMinistry;